import type { NftId } from "@anaconda/core/nft/types"
import { toNftId } from "@anaconda/core/nft/utils"
import { createScope } from "bunshi"

interface ScopeState {
  nftId: NftId
}

export const NftScope = createScope<ScopeState>({
  nftId: toNftId("ETHEREUM:0x00:0"),
})
